import React, {Component} from 'react';
import {View, TouchableOpacity, I18nManager, ActivityIndicator, Image} from 'react-native';
import {moderateScale} from "../../../../../tools/Scaling";
import * as NavigationService from '../../../../../redux/NavigationService';
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import {connect} from "react-redux";
import {Tools} from "../../../../../tools/Tools";
import HMImageView from "../../../../../customviews/HMImageView";
import PathFile from "../../../../../assets/PathFile";
import HMIcon from "../../../../../customviews/HMIcon";


class AdapterListNews extends Component {

    componentWillMount() {

    }

    constructor(props) {
        super(props);

    }

    componentWillReceiveProps(propss) {

    }

    componentWillUnmount() {

    }

    setData(item) {

    }

    render() {
        let {item, index, navigation} = this.props
        return (


            <TouchableOpacity style={{flex: 1, marginHorizontal: moderateScale(8)}}
                              onPress={() => {
                                  //  this.props.callServiceShowWebView("")
                                  NavigationService.navigateParams("DetailsScreen", {item: JSON.stringify(item)})
                              }}
                //onPress={() =>NavigationService.navigateParams("VideoScreen", {id: item.id}) }

            >
                <View style={{
                    padding: moderateScale(3),
                    flexDirection: "row",
                    width: "100%",
                    marginVertical: moderateScale(4),
                    borderRadius: moderateScale(5),
                    backgroundColor: Colors.backgroundColor,
                    // justifyContent: "flex-end"
                }}>

                    <View>

                        <View
                            style={{
                                width: moderateScale(90),
                                height: moderateScale(90),
                                margin: moderateScale(6),
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <HMImageView
                                resizeMode={"cover"}
                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                uriComplete={item.images.file == '' ? null : item.images.file}
                                styleText={{marginTop: moderateScale(10)}} borderRadius={4}/>
                            {
                                item.video ?
                                    <View style={{position: 'absolute', width: '25%', height: '25%'}}>
                                        <HMImageView
                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                            source_image={PathFile.image.img_play}
                                            borderRadius={4}/>

                                    </View>
                                    :
                                    null

                            }

                        </View>
                        {/*     <ImageOverlay
                            containerStyle={{
                                width: moderateScale(90),
                                height: moderateScale(90),
                                marginHorizontal: moderateScale(10)
                            }}
                            //  source={require("../../../assets/img/mainAdvsPlaceholder.jpg")}
                            source={{uri: "https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}}
                            rounded={moderateScale(15)}
                            overlayAlpha={0.3}
                            contentPosition={"center"}
                        >
                            {
                                1 === 1 ?
                                    <Image tintColor={Colors.colorDark}
                                           source={require("../../../assets/img/logo.png")}
                                           style={{width: moderateScale(40), height: moderateScale(40)}}/>
                                    :

                                    null
                            }

                        </ImageOverlay>*/}
                    </View>
                    <View style={{
                        flex: 1,
                        //   justifyContent: "flex-end",
                        marginHorizontal: moderateScale(4),
                    }}>
                        <View style={{
                            //flexDirection: "row",
                            flex: 1,
                            //  width:'100%',
                            //   justifyContent: "flex-end",
                            flexWrap: 'wrap',

                        }}>
                            <HMTextView
                                numberOfLines={3}
                                type={"bold"}
                                // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                text={item.title}
                                style={{
                                    fontSize: moderateScale(12),

                                    color: Colors.blackLight,
                                    marginTop: moderateScale(4),
                                    //   textAlign: "right",
                                }}/>
                        </View>

                        <View style={{flex: 1, flexDirection: 'row'}}>

                            {
                                (Tools.CheckValue(item.modified) === null) ?
                                    null
                                    :
                                    <View style={{
                                        flexDirection: "row",
                                        marginTop: moderateScale(3),
                                        alignItems: "center",
                                    }}>
                                        <HMTextView text={item.modified}
                                                    style={{
                                                        color: Colors.colorDark,
                                                        marginEnd: moderateScale(10),
                                                        fontSize: moderateScale(12),
                                                    }}/>
                                        <HMIcon name={"md-time"}
                                                style={{fontSize: moderateScale(17), color: Colors.colorDark}}/>
                                    </View>
                            }
                            <View style={{flex: 1}}/>
                            {
                                Tools.CheckValue(item.views) !== null ?
                                    null
                                    :
                                    <View style={{
                                        flexDirection: "row",
                                        marginTop: moderateScale(3),
                                        alignItems: "center",
                                    }}>
                                        <HMTextView text={item.view ? item.view : 0}
                                                    style={{
                                                        color: Colors.colorDark,
                                                        marginEnd: moderateScale(10),
                                                        fontSize: moderateScale(12),
                                                    }}/>
                                        <HMIcon name={"md-eye"}
                                                style={{fontSize: moderateScale(17), color: Colors.colorDark}}/>
                                    </View>
                            }
                        </View>
                    </View>


                </View>
            </TouchableOpacity>


        );
    }

}

const mapStateToProps = state => {
    return {


        token: state.reducerSplashGetAllData.token,
        DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const mapDispatchToProps = dispatch => {
    return {}
};
export default connect(mapStateToProps, mapDispatchToProps)(AdapterListNews);
